// ========================================
// WUNSCHLISTE - Nur IDs speichern, Daten live laden
// ========================================

// Wunschlisten-Badge aktualisieren
function updateWishlistBadge() {
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const badge = document.querySelector(".wishlist-count-bubble");
  const count = wishlist.length;

  if (badge) {
    badge.textContent = count;
    badge.style.display = count > 0 ? "inline-flex" : "none";
  }
}

// Produkt zur Wunschliste hinzufügen
function addToWishlist(productUrl, variantId) {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  const wishlistItem = {
    productVariantId: variantId,
    productUrl: productUrl,
    addedAt: new Date().toISOString(),
  };

  if (
    !wishlist.some(
      (item) => item.productVariantId === wishlistItem.productVariantId,
    )
  ) {
    wishlist.push(wishlistItem);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    console.log("Zur Wunschliste hinzugefügt:", wishlistItem);

    updateWishlistBadge();
    showWishlistNotification("Zur Wunschliste hinzugefügt!");
  } else {
    showWishlistNotification("Bereits in der Wunschliste");
  }
}

// Aktuelle Produktdaten von Shopify laden
async function loadWishlistWithCurrentData() {
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const wishlistBlock = document.querySelector(".js-wishlistBlock");
  const addAllButton = document.querySelector("#addAllToCart");

  if (!wishlistBlock) return;

  if (wishlist.length === 0) {
    wishlistBlock.innerHTML = "<p>Ihre Wunschliste ist leer.</p>";
    updateWishlistBadge();

    // Button ausblenden wenn leer
    if (addAllButton) {
      addAllButton.style.display = "none";
    }
    return;
  }

  // Button anzeigen wenn Items vorhanden
  if (addAllButton) {
    addAllButton.style.display = "block";
  }

  wishlistBlock.innerHTML = "<p>Lade Wunschliste...</p>";

  const productsWithData = await Promise.all(
    wishlist.map(async (item) => {
      try {
        const response = await fetch(`${item.productUrl}.js`);

        if (!response.ok) {
          console.warn("Produkt nicht gefunden:", item.productUrl);
          return null;
        }

        const productData = await response.json();
        const variant =
          productData.variants.find((v) => v.id == item.productVariantId) ||
          productData.variants[0];

        return {
          productVariantId: item.productVariantId,
          productUrl: item.productUrl,
          productTitle: productData.title,
          productPrice: (variant.price / 100).toFixed(2),
          productImg: variant.featured_image?.src || productData.featured_image,
          available: variant.available,
        };
      } catch (error) {
        console.error("Fehler beim Laden:", error);
        return null;
      }
    }),
  );

  const validProducts = productsWithData.filter((item) => item !== null);

  if (validProducts.length !== wishlist.length) {
    const validIds = validProducts.map((p) => p.productVariantId);
    const cleanedWishlist = wishlist.filter((item) =>
      validIds.includes(item.productVariantId),
    );
    localStorage.setItem("wishlist", JSON.stringify(cleanedWishlist));
    updateWishlistBadge();
  }

  renderWishlist(validProducts);
}

// Wunschliste rendern
function renderWishlist(wishlistData) {
  const wishlistHtml = wishlistData
    .map(
      (item) => `
      <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover"> 
        <div class="c-product">
          <div class="wishlist-product__image">
            <a href="${item.productUrl}">
              <img src="${item.productImg}" alt="${item.productTitle}">
            </a>

            <button
              type="button"
              class="wishlist-remove-btn"
              data-variant-id="${item.productVariantId}"
              aria-label="Produkt von der Wunschliste entfernen"
              title="Aus Wunschliste entfernen"
            >
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <div>
            <h3 class="c-product__title card__heading h5">
              <a class="full-unstyled-link" href="${item.productUrl}">${
                item.productTitle
              }</a>
            </h3>
            <p>${item.productPrice} €</p>
           
          </div>
          <div class="quick-add">
            <button
              type="button"
              class="quick-add__submit wishlist-quick-add-button quick-add__trigger button button--secondary"
              data-product-id="${item.productVariantId}"
              aria-haspopup="dialog"
              aria-label="Schnellansicht für ${item.productTitle}"
              ${!item.available ? "disabled" : ""}
            >
              ${!item.available ? "Vergriffen" : "In den Warenkorb"}
            </button>
          </div>
        </div>
      </div>
    `,
    )
    .join("");

  document.querySelector(".js-wishlistBlock").innerHTML = wishlistHtml;
  updateWishlistBadge();
}

// Produkt von Wunschliste entfernen
function removeFromWishlist(variantId) {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  wishlist = wishlist.filter((item) => item.productVariantId != variantId);
  localStorage.setItem("wishlist", JSON.stringify(wishlist));

  updateWishlistBadge();
  loadWishlistWithCurrentData();
  showWishlistNotification("Aus Wunschliste entfernt");
}

// Notification anzeigen
function showWishlistNotification(message) {
  const notification = document.createElement("div");
  notification.className = "wishlist-notification";
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #000;
    color: #fff;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 9999;
    animation: wishlist-slideIn 0.3s ease;
  `;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.animation = "wishlist-slideOut 0.3s ease";
    setTimeout(() => notification.remove(), 300);
  }, 2000);
}

// Event Listeners
document.addEventListener("DOMContentLoaded", () => {
  updateWishlistBadge();

  // Auf Wunschlisten-Seite
  if (document.querySelector(".js-wishlistBlock")) {
    loadWishlistWithCurrentData();
  }

  // Auf Produktseite - Button-Status prüfen
  if (document.querySelector(".wishlist_button")) {
    checkWishlistStatus();
    initVariantChangeListener();
  }

  // Remove-Button Handler
  document.addEventListener("click", (e) => {
    if (e.target.closest(".wishlist-remove-btn")) {
      const button = e.target.closest(".wishlist-remove-btn");
      const variantId = button.dataset.variantId;
      removeFromWishlist(variantId);
    }

    // "Alle in den Warenkorb" Button
    if (e.target.closest("#addAllToCart")) {
      e.preventDefault();
      addAllToCart();
    }

    // Einzelnes Produkt in den Warenkorb
    if (e.target.closest(".wishlist-quick-add-button")) {
      e.preventDefault();
      const button = e.target.closest(".wishlist-quick-add-button");
      const variantId = button.dataset.productId;
      addSingleToCart(variantId);
    }
  });
});

// Storage-Änderungen in anderen Tabs
window.addEventListener("storage", (e) => {
  if (e.key === "wishlist") {
    updateWishlistBadge();

    // Auf Produktseite Button-Status aktualisieren
    if (document.querySelector(".wishlist_button")) {
      checkWishlistStatus();
    }

    // Auf Wunschlisten-Seite Liste neu laden
    if (document.querySelector(".js-wishlistBlock")) {
      loadWishlistWithCurrentData();
    }
  }
});

// Migration alter Daten
function migrateOldWishlistData() {
  const oldWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (oldWishlist.length > 0 && oldWishlist[0].productTitle) {
    console.log("Migriere alte Wunschlisten-Daten...");

    const newWishlist = oldWishlist.map((item) => ({
      productVariantId: item.productVariantId,
      productUrl: item.productUrl,
      addedAt: new Date().toISOString(),
    }));

    localStorage.setItem("wishlist", JSON.stringify(newWishlist));
    updateWishlistBadge();
    console.log("Migration abgeschlossen!");
  }
}

migrateOldWishlistData();

// Storage-Änderungen in anderen Tabs
window.addEventListener("storage", (e) => {
  if (e.key === "wishlist") {
    updateWishlistBadge();

    if (document.querySelector(".js-wishlistBlock")) {
      loadWishlistWithCurrentData();
    }
  }
});

// Warenkorb-Update für Dawn Theme
function refreshCart() {
  // Am Anfang der refreshCart() Funktion:
  console.log("=== Cart Refresh Debug ===");
  console.log(
    "Cart Count Bubble:",
    document.querySelector(".cart-count-bubble"),
  );
  console.log(
    "Aria Hidden Span:",
    document.querySelector('.cart-count-bubble span[aria-hidden="true"]'),
  );
  console.log(
    "Visually Hidden Span:",
    document.querySelector(".cart-count-bubble span.visually-hidden"),
  );

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const itemCount = cart.item_count;

      // Update Cart Count Bubble
      const cartCountBubble = document.querySelector(".cart-count-bubble");
      if (cartCountBubble) {
        // Update beide spans (sichtbar und visually-hidden)
        const ariaHiddenSpan = cartCountBubble.querySelector(
          'span[aria-hidden="true"]',
        );
        const visuallyHiddenSpan = cartCountBubble.querySelector(
          "span.visually-hidden",
        );

        if (ariaHiddenSpan) {
          ariaHiddenSpan.textContent = itemCount;
        }

        if (visuallyHiddenSpan) {
          visuallyHiddenSpan.textContent =
            itemCount === 1 ? "1 Artikel" : `${itemCount} Artikel`;
        }

        // Bubble anzeigen/verstecken
        if (itemCount > 0) {
          cartCountBubble.classList.remove("hidden");
          cartCountBubble.style.display = "";
        } else {
          cartCountBubble.classList.add("hidden");
        }
      }

      // Dawn-spezifisches Event
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        }),
      );

      // Update Cart Drawer falls vorhanden
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        fetch(`${window.location.pathname}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newDrawerContent = doc.querySelector(".drawer__inner");
            const currentDrawerContent =
              cartDrawer.querySelector(".drawer__inner");

            if (newDrawerContent && currentDrawerContent) {
              currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
            }
          })
          .catch((err) => console.log("Drawer update failed:", err));
      }

      // Trigger Shopify theme event (falls vorhanden)
      if (typeof Shopify !== "undefined" && Shopify.theme) {
        document.dispatchEvent(new CustomEvent("shopify:section:load"));
      }
    })
    .catch((err) => console.error("Cart refresh failed:", err));
}

// Alle Produkte aus Wunschliste in den Warenkorb legen
async function addAllToCart() {
  console.log("=== addAllToCart gestartet ===");

  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (wishlist.length === 0) {
    showWishlistNotification("Deine Wunschliste ist leer");
    return;
  }

  const addAllButton = document.querySelector("#addAllToCart");
  const originalText = addAllButton ? addAllButton.textContent : "";

  if (addAllButton) {
    addAllButton.disabled = true;
    addAllButton.style.opacity = "0.5";
    addAllButton.style.cursor = "not-allowed";
    addAllButton.textContent = "Wird hinzugefügt...";
  }

  try {
    console.log("Lade Produktdaten...");
    const productsWithData = await Promise.all(
      wishlist.map(async (item) => {
        try {
          const response = await fetch(`${item.productUrl}.js`);
          if (!response.ok) return null;

          const productData = await response.json();
          const variant =
            productData.variants.find((v) => v.id == item.productVariantId) ||
            productData.variants[0];

          return {
            id: variant.id,
            quantity: 1,
            available: variant.available,
          };
        } catch (error) {
          return null;
        }
      }),
    );

    const availableProducts = productsWithData.filter(
      (item) => item && item.available,
    );
    console.log("Verfügbare Produkte:", availableProducts);

    if (availableProducts.length === 0) {
      showWishlistNotification("Keine verfügbaren Produkte in der Wunschliste");
      if (addAllButton) {
        addAllButton.disabled = false;
        addAllButton.style.opacity = "1";
        addAllButton.style.cursor = "pointer";
        addAllButton.textContent = originalText;
      }
      return;
    }

    console.log("Sende an /cart/add.js:", availableProducts);
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: availableProducts,
      }),
    });

    console.log("Response Status:", response.status);
    console.log("Response OK:", response.ok);

    if (response.ok) {
      const responseData = await response.json();
      console.log("Response Data:", responseData);

      const unavailableCount = wishlist.length - availableProducts.length;
      let message = `${availableProducts.length} Artikel in den Warenkorb gelegt`;

      if (unavailableCount > 0) {
        message += ` (${unavailableCount} vergriffen)`;
      }

      showWishlistNotification(message);

      // Warenkorb aktualisieren
      console.log("Rufe refreshCart() auf...");
      refreshCart();

      // Optional: Cart Drawer öffnen
      setTimeout(() => {
        const cartDrawer = document.querySelector("cart-drawer");
        console.log("Cart Drawer Element:", cartDrawer);
        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      }, 400);
    } else {
      const errorText = await response.text();
      console.error("Error Response:", errorText);
      throw new Error("Fehler beim Hinzufügen zum Warenkorb");
    }
  } catch (error) {
    console.error("Fehler in addAllToCart:", error);
    showWishlistNotification("Fehler beim Hinzufügen zum Warenkorb");
  } finally {
    if (addAllButton) {
      addAllButton.disabled = false;
      addAllButton.style.opacity = "1";
      addAllButton.style.cursor = "pointer";
      addAllButton.textContent = originalText;
    }
  }
}

// Einzelnes Produkt in den Warenkorb legen
async function addSingleToCart(variantId) {
  console.log("=== addSingleToCart gestartet ===", variantId);

  const button = document.querySelector(`[data-product-id="${variantId}"]`);
  const originalText = button ? button.textContent : "";

  if (button) {
    button.disabled = true;
    button.textContent = "Wird hinzugefügt...";
  }

  try {
    console.log("Sende an /cart/add.js:", variantId);
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    });

    console.log("Response Status:", response.status);
    console.log("Response OK:", response.ok);

    if (response.ok) {
      const responseData = await response.json();
      console.log("Response Data:", responseData);

      showWishlistNotification("In den Warenkorb gelegt");

      // Warenkorb aktualisieren
      console.log("Rufe refreshCart() auf...");
      refreshCart();

      // Optional: Cart Drawer öffnen
      setTimeout(() => {
        const cartDrawer = document.querySelector("cart-drawer");
        console.log("Cart Drawer Element:", cartDrawer);
        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      }, 300);
    } else {
      const errorText = await response.text();
      console.error("Error Response:", errorText);
      throw new Error("Fehler beim Hinzufügen");
    }
  } catch (error) {
    console.error("Fehler in addSingleToCart:", error);
    showWishlistNotification("Fehler beim Hinzufügen zum Warenkorb");
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }
}

// Warenkorb-Update für Dawn Theme
// Warenkorb-Update für Dawn Theme
function refreshCart() {
  console.log("=== refreshCart() aufgerufen ===");

  fetch("/cart.js")
    .then((response) => {
      console.log("cart.js Response:", response);
      return response.json();
    })
    .then((cart) => {
      console.log("Cart Data:", cart);
      const itemCount = cart.item_count;
      console.log("Item Count:", itemCount);

      // Update Cart Count Bubble - spezifischer Selektor um Wishlist-Bubble zu vermeiden
      const cartCountBubble = document.querySelector(
        "#cart-icon-bubble .cart-count-bubble",
      );
      console.log("Cart Count Bubble Element:", cartCountBubble);

      if (cartCountBubble) {
        // Update beide spans (sichtbar und visually-hidden)
        const ariaHiddenSpan = cartCountBubble.querySelector(
          'span[aria-hidden="true"]',
        );
        const visuallyHiddenSpan = cartCountBubble.querySelector(
          "span.visually-hidden",
        );

        console.log("Aria Hidden Span:", ariaHiddenSpan);
        console.log("Visually Hidden Span:", visuallyHiddenSpan);

        if (ariaHiddenSpan) {
          ariaHiddenSpan.textContent = itemCount;
          console.log("Updated aria-hidden span to:", itemCount);
        }

        if (visuallyHiddenSpan) {
          const text = itemCount === 1 ? "1 Artikel" : `${itemCount} Artikel`;
          visuallyHiddenSpan.textContent = text;
          console.log("Updated visually-hidden span to:", text);
        }

        // Bubble anzeigen/verstecken
        if (itemCount > 0) {
          cartCountBubble.classList.remove("hidden");
          cartCountBubble.style.display = "";
          console.log("Bubble sichtbar gemacht");
        } else {
          cartCountBubble.classList.add("hidden");
          console.log("Bubble versteckt");
        }
      } else {
        console.error("Cart Count Bubble nicht gefunden!");
      }

      // Dawn-spezifisches Event
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        }),
      );
      console.log("cart:refresh Event getriggert");

      // Update Cart Drawer falls vorhanden
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        fetch(`${window.location.pathname}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newDrawerContent = doc.querySelector(".drawer__inner");
            const currentDrawerContent =
              cartDrawer.querySelector(".drawer__inner");

            if (newDrawerContent && currentDrawerContent) {
              currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
            }
          })
          .catch((err) => console.log("Drawer update failed:", err));
      }
    })
    .catch((err) => {
      console.error("Cart refresh failed:", err);
    });
}

// Toggle Wishlist - Produkt hinzufügen/entfernen
function toggleWishlist() {
  // Hole Produktdaten aus der Seite
  const productUrl = window.location.pathname;
  const productData = getProductDataFromPage();

  if (!productData) {
    console.error("Produktdaten konnten nicht geladen werden");
    return;
  }

  const variantId = productData.variantId;
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  // Prüfe ob Produkt bereits in Wunschliste
  const existingIndex = wishlist.findIndex(
    (item) => item.productVariantId === variantId,
  );

  if (existingIndex > -1) {
    // Produkt entfernen
    wishlist.splice(existingIndex, 1);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    updateWishlistBadge();
    updateWishlistButton(false);
    showWishlistNotification("Aus Wunschliste entfernt");
  } else {
    // Produkt hinzufügen
    const wishlistItem = {
      productVariantId: variantId,
      productUrl: productUrl,
      addedAt: new Date().toISOString(),
    };

    wishlist.push(wishlistItem);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    updateWishlistBadge();
    updateWishlistButton(true);
    showWishlistNotification("Zur Wunschliste hinzugefügt!");
  }
}

// Produktdaten von der Seite holen
function getProductDataFromPage() {
  // Methode 1: Aus Shopify Product JSON (am zuverlässigsten)
  if (
    typeof window.ShopifyAnalytics !== "undefined" &&
    window.ShopifyAnalytics.meta
  ) {
    const productId = window.ShopifyAnalytics.meta.product.id;
    const variantId = window.ShopifyAnalytics.meta.product.variants[0].id;

    return {
      productId: productId,
      variantId: variantId,
    };
  }

  // Methode 2: Aus Formular (falls Varianten-Selector vorhanden)
  const variantSelect = document.querySelector('select[name="id"]');
  if (variantSelect) {
    return {
      variantId: parseInt(variantSelect.value),
    };
  }

  // Methode 3: Aus verstecktem Input
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    return {
      variantId: parseInt(variantInput.value),
    };
  }

  // Methode 4: Aus data-Attribut am Formular
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    const variantId = productForm.querySelector('[name="id"]')?.value;
    if (variantId) {
      return {
        variantId: parseInt(variantId),
      };
    }
  }

  console.error("Keine Produktdaten gefunden");
  return null;
}

// Wishlist-Button visuell aktualisieren (gefüllt/ungefüllt)
function updateWishlistButton(isInWishlist) {
  const button = document.querySelector(".wishlist_button");
  if (!button) return;

  const path = button.querySelector("path");

  if (isInWishlist) {
    // Gefülltes rotes Herz
    button.classList.add("is-active");
    if (path) {
      // Gefüllter Pfad
      path.setAttribute(
        "d",
        "M16.5 3C14.76 3 13.09 3.81 12 5.09 10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3z",
      );
      path.setAttribute("fill", "#e74c3c"); // Rot gefüllt
      path.removeAttribute("stroke");
      path.removeAttribute("stroke-width");
    }
  } else {
    // Leeres Herz mit schwarzem Border (nutze den Original-Pfad)
    button.classList.remove("is-active");
    if (path) {
      // Original Outline-Pfad (der bereits einen Border hat)
      path.setAttribute(
        "d",
        "M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z",
      );
      path.setAttribute("fill", "#000000"); // Schwarze Füllung für den Border-Effekt
      path.removeAttribute("stroke");
      path.removeAttribute("stroke-width");
    }
  }
}

// Prüfe beim Laden der Produktseite ob Produkt in Wunschliste ist
function checkWishlistStatus() {
  const productData = getProductDataFromPage();
  if (!productData) return;

  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const isInWishlist = wishlist.some(
    (item) => item.productVariantId === productData.variantId,
  );

  updateWishlistButton(isInWishlist);
}

// Bei Varianten-Wechsel Button-Status aktualisieren
function initVariantChangeListener() {
  // Varianten-Select beobachten
  const variantSelect = document.querySelector('select[name="id"]');
  if (variantSelect) {
    variantSelect.addEventListener("change", () => {
      checkWishlistStatus();
    });
  }

  // Radio-Buttons für Varianten beobachten
  const variantRadios = document.querySelectorAll('input[name="id"]');
  variantRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      checkWishlistStatus();
    });
  });

  // Variant Picker (moderne Themes)
  const variantPicker = document.querySelector(
    "variant-selects, variant-radios",
  );
  if (variantPicker) {
    variantPicker.addEventListener("change", () => {
      setTimeout(checkWishlistStatus, 100); // Kurze Verzögerung für DOM-Update
    });
  }
}
